import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { Button } from 'shared/components';

import theme from './AppointmentsSidebarFetchErrorPlaceholder.scss';

const propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
  fetchAppointmentsByQueueType: PropTypes.func.isRequired,
};

const AppointmentsSidebarFetchErrorPlaceholder = ({ intl, fetchAppointmentsByQueueType }) => (
  <div className={ theme.root }>
    <div className={ theme.message }>
      <div className={ theme.messageText }>
        <FormattedMessage
          id="schedule.appointmentsSidebarFetchErrorPlaceholder.fetchError"
          defaultMessage="** Could not load list. Check internet connection and click the refresh button"
        />
      </div>

      <Button
        testId="appointments-refresh-button"
        buttonType="naked"
        label={ intl.formatMessage({
          id: 'schedule.appointmentsSidebarFetchErrorPlaceholder.refresh',
          defaultMessage: '** Refresh',
        }) }
        iconName="refresh"
        iconPositionLeft={ true }
        size="large"
        mediaResized={ true }
        onClick={ fetchAppointmentsByQueueType }
      />
    </div>
  </div>
);


AppointmentsSidebarFetchErrorPlaceholder.propTypes = propTypes;

export default AppointmentsSidebarFetchErrorPlaceholder;
